<template>
  <app-logged id="VinculoUpdate">
    <v-flex xs12>
      <v-form>
        <app-widget
          actions
          class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
        >
          <div slot="widget-content">
            <AppFormHeader
              title="Atualizar parâmetros do evento"
              :subtitle="`${evento.cliente_nome} | ${evento.industria_nome}`"
              icon="supervised_user_circle"
            />
            <v-checkbox
              hide-details
              v-model="evento.foto"
              label="Foto"
            />
            <v-checkbox
              hide-details
              v-model="evento.indicadores"
              label="Indicatores"
            />
            <v-checkbox
              hide-details
              v-model="evento.balancete"
              label="Balancete"
            />
            <v-checkbox
              hide-details
              v-model="evento.laudo"
              label="Laudo"
            />
          </div>
          <div slot="widget-actions">
            <app-button @click.native="save">
              salvar
            </app-button>
          </div>
        </app-widget>
      </v-form>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
import AppFormHeader from '@/components/AppFormHeader'
export default {
  name: 'VinculoUpdate',
  components: {
    AppWidget,
    AppLogged,
    AppFormHeader,
    AppButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['evento'])
  },
  methods: {
    ...mapActions(['putSaveEvento']),
    return () {
      this.$router.push({
        name: 'controle-eventos-details',
        params: {
          id: Number(this.$route.params.industria)
        }
      })
    },
    async save () {
      await this.putSaveEvento()
      return this.return()
    }
  }
}
</script>
